var map = {
	"./Auth Manage.svg": "6da5",
	"./Basic Setting.svg": "e947",
	"./Dashboard.svg": "b26f",
	"./History.svg": "e227",
	"./Message Push.svg": "f53d",
	"./My Application.svg": "f795",
	"./Personal Setting.svg": "47dc",
	"./Process Manage.svg": "ac2e",
	"./Staff System.svg": "164d",
	"./System Setting.svg": "8e87",
	"./Worker System.svg": "966b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7f93";